export interface IMedicalDevice {
    medicalDeviceId: string,
    gmdnTermCode: number,
    termName: string,
    termDefinition: string,
    copyright: string,
    sfdaDate: string,
    termStatus: number,
    termIsIvd: number,
    modifiedDate: string,
    obsoletedDate: string,
    codeStatus: number,
    inactiveDate?:string;
    codeStatusNameArabic?:string;
    codeStatusNameEnglish?:string;
    termIsIvdNameArabic?:string;
    termIsIvdNameEnglish?:string;
    termStatusNameArabic?:string;
    termStatusNameEnglish?:string;
}

export const medicalDeviceConfig = {
    entityName: 'CONFIGURATION.MEDICAL_DEVICE.TITLE',
    gmdnTermCode: 'FORM_FIELD.TERM_CODE',
    termName: 'FORM_FIELD.TERM_NAME',
    termDefinition: 'FORM_FIELD.TERM_DEFINATION',
    copyright: 'FORM_FIELD.COPYRIGHT',
    sfdaDate: 'FORM_FIELD.SFDA_DATE',
    modifiedDate: 'FORM_FIELD.MODIFIED_DATE',
    obsoletedDate: 'FORM_FIELD.OBSOLATED_DATE',
    inactiveDate: 'FORM_FIELD.INACTIVE_DATE',
    termStatus: 'FORM_FIELD.TERM_STATUS',
    termIsIvd: 'FORM_FIELD.TERM_ISIVD',
    codeStatus: 'FORM_FIELD.CODE_STATUS'
};